import React from 'react';
import { ChevronRight, Info, QrCode, UserX } from 'lucide-react';
import { MobileHeader } from '../MobileHeader';
import { VerifyStepper } from '../VerifyStepper';
import { PersonPhoto } from '../../common/PersonPhoto';
import { cngs } from '../../../data/cngs';
import { getDriver } from '../../../data/drivers';
import type { Driver } from '../../../types/domain';
import type { MobileNav } from '../../../types/mobile';
export function DriversScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const cng = cngs[0];
  const list = cng.driverIds.map(id => getDriver(id)).filter((d): d is Driver => Boolean(d));
  const open = (id: string) => {
    nav.setDriverId(id);
    nav.go('driver');
  };
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-255" data-mp="3se3ncgkplpz2">
      <MobileHeader title="অনুমোদিত চালক (৩)" subtitle={cng.reg} onBack={nav.back} data-id="element-256" data-mp="3sfohw670x8wx" />
      <VerifyStepper current={2} data-id="element-257" data-mp="1vka6tk95lb8o" />
      <div className="no-scrollbar flex-1 overflow-y-auto p-4" data-id="element-258" data-mp="1qm8f6axnw3ll">
        <div className="mb-3 flex gap-2 rounded-lg border border-blue-200 bg-blue-50 p-3 text-xs text-blue-800" data-id="element-259" data-mp="1qmqmq3pry48t">
          <Info className="h-4 w-4 shrink-0" data-id="element-260" data-mp="t3dxk15a8ikq" />
          <p data-id="element-261" data-mp="y171enj450hu">গাড়ি চালনারত ব্যক্তির চেহারা ছবির সাথে মিলিয়ে <b data-id="element-262" data-mp="xxrl5hdpdleu">বর্তমান চালক</b> নির্বাচন করুন, অথবা চালকের QR কার্ড স্ক্যান করুন।</p>
        </div>
        <button onClick={() => {
        nav.showToast('চালকের QR কার্ড শনাক্ত: DRV-000001');
        open('d1');
      }} className="mb-3 flex w-full items-center justify-center gap-2 rounded-lg border-2 border-dashed border-navy-300 bg-white py-3 text-sm font-semibold text-navy-800" data-id="element-263" data-mp="k2fo33c2riur">
          <QrCode className="h-4 w-4" data-id="element-264" data-mp="12zh0h97ykl8q" /> চালকের QR কার্ড স্ক্যান করুন
        </button>

        <div className="space-y-2.5" data-id="element-265" data-mp="17ybpwu0fl81t">
          {list.map((d, i) => <button key={d.id} onClick={() => open(d.id)} className="w-full rounded-xl border border-border bg-white p-3 text-left transition hover:border-navy-300 active:scale-[0.99]" data-id="element-266" data-mp="17w7cnlgn6wov" data-mpi={i}>
              <div className="flex gap-3" data-id="element-267" data-mp="20g5zkv5ix9ef">
                <PersonPhoto src={d.photo} name={d.name} size={64} rounded="md" data-id="element-268" data-mp="2aabhzq1vq9b9" />
                <div className="min-w-0 flex-1" data-id="element-269" data-mp="2a88sd74n2i72">
                  <div className="flex items-start justify-between gap-1" data-id="element-270" data-mp="25cjr8zcz0t8n">
                    <div data-id="element-271" data-mp="20bvzgbgx48dd">
                      <p className="text-[10px] font-semibold text-slate-400" data-id="element-272" data-mp="20b43gzjes8mk">চালক {['১', '২', '৩'][i]}</p>
                      <p className="text-sm font-bold text-navy-900" data-id="element-273" data-mp="1vcsuer0xu25e">{d.name}</p>
                    </div>
                    <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700" data-id="element-274" data-mp="1rda8pt1aln1i">✓ সক্রিয়</span>
                  </div>
                  <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-2 text-[11px]" data-id="element-275" data-mp="1hlebek7160yc">
                    <dt className="text-slate-500" data-id="element-276" data-mp="1cn32cbok7uh6">লাইসেন্স:</dt><dd className="font-mono text-navy-900" data-id="element-277" data-mp="1coe4k72cwu66">{d.license}</dd>
                    <dt className="text-slate-500" data-id="element-278" data-mp="17nzvqmsxlg73">NID:</dt><dd className="font-mono text-navy-900" data-id="element-279" data-mp="17mygs78so9k3">{d.nid}</dd>
                    <dt className="text-slate-500" data-id="element-280" data-mp="13nfy7i4g4akf">মোবাইল:</dt><dd className="font-mono text-navy-900" data-id="element-281" data-mp="13oiobnty28za">{d.mobile}</dd>
                    <dt className="text-slate-500" data-id="element-282" data-mp="3f8ypfd5w42il">মেয়াদ:</dt><dd className="text-navy-900" data-id="element-283" data-mp="3jatkw1153log">{d.expiry}</dd>
                  </dl>
                </div>
              </div>
              <div className="mt-2 flex items-center justify-end gap-1 border-t border-slate-100 pt-2 text-xs font-semibold text-navy-700" data-id="element-284" data-mp="3ob7vnqu4l9q6">
                বর্তমান চালক হিসেবে নির্বাচন <ChevronRight className="h-4 w-4" data-id="element-285" data-mp="2vlsk8zyjtetq" />
              </div>
            </button>)}
        </div>

        <button onClick={() => {
        nav.setReportContext('unauthorized');
        nav.go('report');
      }} className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 py-3 text-sm font-semibold text-red-700" data-id="element-286" data-mp="30k2d33wsw3c6">
          <UserX className="h-4 w-4" data-id="element-287" data-mp="2cvt08rhkepx6" /> বর্তমান চালক তালিকায় নেই
        </button>
      </div>
    </div>;
}